import { Component } from '@angular/core';

@Component({
  selector: 'app-diag-test',
  standalone: true,
  imports: [],
  templateUrl: './diag-test.component.html',
  styleUrl: './diag-test.component.css'
})
export class DiagTestComponent {

}
